import React, { useEffect, useState } from 'react';
import { FaFileDownload, FaRegHeart, FaHeart, FaCopy, FaEye } from 'react-icons/fa';
import { Link, useParams } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import countapi from 'countapi-js';

import { client, urlFor } from '../client';
//import MasonryLayout from './MasonryLayout';
import Masonic from './Masonic';
import { promptDetailMorePromptQuery, promptDetailQuery } from '../utils/data';
import Spinner from './Spinner';

// import { themeChange } from 'theme-change';


const PromptDetail = ({ user }) => {
  const { promptId } = useParams();
  const [prompts, setPrompts] = useState();
  const [promptDetail, setPromptDetail] = useState();
  const [promptPageCount, setPromptPageCount] = useState();


  const fetchPromptDetails = () => {
    const query = promptDetailQuery(promptId);

    if (query) {
      client.fetch(`${query}`).then((data) => {
        setPromptDetail(data[0]);
        
        if (data[0]) {
          const query1 = promptDetailMorePromptQuery(data[0]);
          client.fetch(query1).then((res) => {
            setPrompts(res);
          });
        }
      });
    }
  };

  useEffect(() => {
    fetchPromptDetails();
    countapi.hit('prompthaven.com', promptId).then((result) => { 
      setPromptPageCount(result.value);
     });
  }, [promptId]);

  // useEffect(() => {
  //    themeChange(false);
  // }, []);



  if (!promptDetail) {
    return (
      <Spinner message="Showing prompt" />
    );
  }

  const alreadySaved = !!(promptDetail?.favourite?.filter((item) => item?.postedBy?._id === user?._id))?.length;

  const savePrompt = (promptId) => {
    if(!alreadySaved) {

      client
        .patch(promptId)
        .setIfMissing({ favourite: [] })
        .insert('after', 'favourite[-1]', [{
          _key: uuidv4(),
          userId: user?._id,
          postedBy: {
            _type: 'postedBy',
            _ref: user?._id
          }
        }])
        .commit()
        .then(() => {
          fetchPromptDetails();
          window.location.reload();
        })
    } else {
      client
        .patch(promptId)
        .unset( ['favourite[userId=="'+user?._id+'"]'])
        .commit()
        .then(() => {
          fetchPromptDetails();
          window.location.reload();
        })
    }
  }

  // countapi.visits().then((result) => {
  //   console.log(promptDetail._id);
  //   //console.log(result.value);
  // });



  return (

    <>


      {promptDetail && (
        <div className="flex xl:flex-row flex-col m-auto bg-white" >

          
    
<section class="text-gray-600 body-font overflow-hidden">
  <div class="container px-5 py-5 mx-auto">
    <div class=" mx-auto flex flex-wrap">
      
      <img src={(promptDetail?.image && urlFor(promptDetail?.image).url())} alt="user-post" class="lg:w-1/2 w-full lg:h-auto h-auto object-cover object-center rounded" />

      <div class="lg:w-1/2 w-full lg:pl-10 lg:py-6 mt-6 lg:mt-0">

      <div className="overflow-hidden bg-white shadow sm:rounded-lg">
      <div className="px-4 py-5 sm:px-6">
      
        <h3 className="text-lg font-medium leading-6 text-gray-900">{promptDetail.title}</h3>
        
      </div>

      <div className="border-t border-gray-200">
        <dl>
          <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">AI Generator</dt>
            <dd className="badge badge-primary uppercase tracking-widest mt-1 max-w-2xl text-xs mb-2 rounded-full">{promptDetail.type} </dd>
          </div>
          <div className="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">Prompt</dt>
            
            <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">{promptDetail.line}</dd>
            
          </div>
          <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">Instruction</dt>
            <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">{promptDetail.instruction}</dd>
          </div>
          <div className="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt className="text-sm font-medium text-gray-500">Views </dt>
          <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">{promptPageCount}</dd>
          </div>
          <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">Created by</dt>
            <Link to={`/user-profile/${promptDetail?.postedBy._id}`} className="flex gap-2 items-center">
              <img src={promptDetail?.postedBy.image} className="w-7 h-7 rounded-full" alt="user-profile" />
              <p className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0 link">{promptDetail?.postedBy.userName}</p>
          </Link>
          </div>
          <div className="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt className="text-sm font-medium text-gray-500">License</dt>
          <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0"><b>PromptHaven</b> grants you an irrevocable, nonexclusive, worldwide copyright license to download, copy, modify, distribute, perform, 
                and use photos and prompt details from PromptHaven for free, including for commercial purposes, without permission from or attributing the creator or PromptHaven. </dd>
          </div>

        </dl>
      </div>
    </div>

        
    
       
        
        <div class="flex mt-5">

        <button className="btn btn-primary gap-2 rounded-full" onClick={() => {navigator.clipboard.writeText(`${promptDetail.line}`)}}><FaCopy size={20}/> Copy Prompt</button>


                {alreadySaved ? (
                  <button onClick={(e) => {
                    e.stopPropagation();
                    savePrompt(promptDetail._id);
                  }} className="btn ml-auto gap-2 rounded-full">
                  <FaHeart size={20} />{promptDetail.favourite.length} 
                  </button>
                ): (
                  <button  onClick={(e) => {
                    e.stopPropagation();
                    savePrompt(promptDetail._id);
                  }} className="btn btn-square btn-outline ml-auto rounded-full">
                   <FaRegHeart size={20} />
                  </button>
                )}
             
             
          
        </div>


      </div>

      
      
    </div>
  </div>
</section>

          
        </div>

      )}
 {/* {prompts?.length > 0 && (
<section class="text-gray-600 body-font">
  <div class="container px-5 py-24 mx-auto">
    <div class="flex flex-col">
      <div class="h-1 bg-gray-200 rounded overflow-hidden">
        <div class="w-24 h-full bg-slate-900"></div>
      </div>
      <div class="flex flex-wrap sm:flex-row flex-col py-6 mb-12">
        <h1 class="sm:w-2/5 text-gray-900 font-medium title-font text-2xl mb-2 sm:mb-0">More {promptDetail.type} Prompts</h1>
        
      </div>
    </div>
    <div >
    {prompts ? (
        <Masonic prompts={prompts} page={"loadMore"} />
      ) : (
        <Spinner message="Loading more prompts" />
      )}
    </div>
  </div>
</section>
)} */}
      
    </>
  );
};

/*
        <button class="rounded-full w-10 h-10 bg-gray-200 p-0 border-0 inline-flex items-center justify-center text-gray-500 text-xl ml-4 opacity-75 hover:opacity-100">
            <FaRegHeart />
        </button>


        <Link to={`/user-profile/${promptDetail?.postedBy._id}`} className="flex ml-auto gap-2 items-center">
                    <img src={promptDetail?.postedBy.image} className="w-10 h-10 rounded-full" alt="user-profile" />
                    <p className="text-gray-900 font-medium">{promptDetail?.postedBy.userName}</p>
              </Link>

                      <blockquote class="p-4 my-4 bg-gray-50 border-l-4 border-gray-300  ">
    <p class="text-xl italic font-medium leading-relaxed text-gray-900 ">{promptDetail.line}</p>
</blockquote>

        <span class="inline-block py-1 px-2 rounded bg-blue-50 text-blue-500 text-xs font-medium tracking-widest uppercase mb-4">{promptDetail.type}</span>


        <a href={`${promptDetail.image.asset.url}?dl=`} download className="ml-auto rounded-full w-10 h-10 bg-gray-200 p-0 border-0 inline-flex items-center justify-center text-gray-500 text-xl opacity-75 hover:opacity-100">
            <FaFileDownload /> 
        </a>
            <button type='button' className='rounded-full h-10 bg-gray-200 p-0 border-0 inline-flex items-center gap-2 justify-center text-black text-xl ml-4 pl-4 pr-4 opacity-75 hover:opacity-100'>
                <FaEye />{promptPageCount} 
            </button>

                {alreadySaved ? (
                  <button type='button' className='rounded-full h-10 bg-gray-200 p-0 border-0 inline-flex items-center gap-2 justify-center text-black text-xl ml-4 pl-4 pr-4 opacity-75 hover:opacity-100'>
                   <FaHeart  />{promptDetail.favourite.length} 
                  </button>
                ): (
                  <button 
                    onClick={(e) => {
                      e.stopPropagation();
                      savePrompt(promptDetail._id);
                    }}  
                  type='button' className='rounded-full w-10 h-10 bg-gray-200 p-0 border-0 inline-flex items-center justify-center text-gray-500 text-xl ml-4 opacity-75 hover:opacity-100'>
                    <FaRegHeart  />
                  </button>

                  <button className="btn btn-square btn-outline">
                   <FaRegHeart  />
                  </button>
                )}

*/

/*
<>


      {promptDetail && (
        <div className="flex xl:flex-row flex-col m-auto bg-white" >

          
    
<section class="text-gray-600 body-font overflow-hidden">
  <div class="container px-5 py-5 mx-auto">
    <div class=" mx-auto flex flex-wrap">
      
      <img src={(promptDetail?.image && urlFor(promptDetail?.image).url())} alt="user-post" class="lg:w-1/2 w-full lg:h-auto h-auto object-cover object-center rounded" />

      <div class="lg:w-1/2 w-full lg:pl-10 lg:py-6 mt-6 lg:mt-0">

        <div className="badge badge-primary text-xs uppercase tracking-widest mb-4">{promptDetail.type} </div>
        <h1 class="text-gray-900 text-3xl title-font font-medium mb-1 capitalize">{promptDetail.title}</h1>

        <div class="flex mb-6 items-center pt-5 border-t-2 border-gray-100 mt-5">
        </div>
        
        <blockquote class="p-4 my-4 bg-gray-50 border-l-4 border-gray-300  ">
            <p class="text-xl italic font-medium leading-relaxed text-gray-700 lowercase">{promptDetail.line}</p>
            <button className="btn btn-sm btn-circle btn-outline flex ml-auto" onClick={() => {navigator.clipboard.writeText(`${promptDetail.line}`)}}><FaCopy /></button>
        </blockquote>

        <p class="leading-relaxed">{promptDetail.instruction} </p>

        <div class="flex mt-6 items-center pb-5 border-b-2 border-gray-100 mb-5">
        </div>

        <div class="flex">

        <Link to={`/user-profile/${promptDetail?.postedBy._id}`} className="flex gap-2 items-center">
              <img src={promptDetail?.postedBy.image} className="w-10 h-10 rounded-full" alt="user-profile" />
              <p className="text-gray-900 font-medium">{promptDetail?.postedBy.userName}</p>
        </Link>

       <button className='btn' data-set-theme="black" data-act-class="ACTIVECLASS">black</button>
        <button className='btn' data-set-theme="lofi" data-act-class="ACTIVECLASS">lofi</button> 



        <a href={`${promptDetail.image.asset.url}?dl=`} download className="ml-auto rounded-full w-10 h-10 bg-gray-200 p-0 border-0 inline-flex items-center justify-center text-gray-500 text-xl opacity-75 hover:opacity-100">
            <FaFileDownload /> 
        </a>
        <button className="btn gap-2">
                  <FaEye />{promptPageCount} 
                  </button>

                {alreadySaved ? (
                  <button className="btn gap-2">
                  <FaHeart  />{promptDetail.favourite.length} 
                  </button>
                ): (
                  <button  onClick={(e) => {
                    e.stopPropagation();
                    savePrompt(promptDetail._id);
                  }} className="btn btn-square btn-outline">
                   <FaRegHeart size={20} />
                  </button>
                )}
             
             
          
        </div>
        <p className='invisible'>Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, </p>
      </div>
      
    </div>
  </div>
</section>

          
        </div>

      )}
 {prompts?.length > 0 && (
<section class="text-gray-600 body-font">
  <div class="container px-5 py-24 mx-auto">
    <div class="flex flex-col">
      <div class="h-1 bg-gray-200 rounded overflow-hidden">
        <div class="w-24 h-full bg-slate-900"></div>
      </div>
      <div class="flex flex-wrap sm:flex-row flex-col py-6 mb-12">
        <h1 class="sm:w-2/5 text-gray-900 font-medium title-font text-2xl mb-2 sm:mb-0">More {promptDetail.type} Prompts</h1>
        
      </div>
    </div>
    <div >
    {prompts ? (
        <Masonic prompts={prompts} page={"loadMore"} />
      ) : (
        <Spinner message="Loading more prompts" />
      )}
    </div>
  </div>
</section>
)} 
      
    </>

*/


/*

        <a href={`${promptDetail.image.asset.url}?dl=`} download className="btn btn-circle btn-outline">
            <FaFileDownload /> 
        </a>
        
*/
        {/* <button className='btn' data-set-theme="black" data-act-class="ACTIVECLASS">black</button>
        <button className='btn' data-set-theme="lofi" data-act-class="ACTIVECLASS">lofi</button> */}

    
export default PromptDetail